import "angular-drag-and-drop-lists";

import uiBootstrap from "@gtmhub/ui-bootstrap.module";
import ngExtensions from "@gtmhub/shared/ng-extensions/ng-extensions.module";
import { GridFilteringBarComponent } from "./grid-filtering-bar.component";
import { GridFiltersComponent } from "./grid-filters/grid-filters.component";
import { GridSortingComponent } from "./grid-sorting/grid-sorting.component";
import { GridColumnsComponent } from "./grid-columns/grid-columns.component";
import { GridFiltersTagFactory } from "./grid-filters/grid-filters-tag-factory";
import { GridFiltersArrayQueryService } from "./grid-filters/grid-filters-array-query-service";
import { GridFiltersDynamicValueFactory } from "./grid-filters/grid-filters-dynamic-value-factory";
import { GridSettingsComponent } from "./grid-settings/grid-settings.component";
import { GridFiltersTagAvatarComponent } from "./grid-filters/grid-filters-tag-avatar.component";

const mod = angular
  .module("gridFilteringBar", [uiBootstrap, ngExtensions, "ngTagsInput", "dndLists"])
  .component("gridFilteringBar", GridFilteringBarComponent)
  .component("gridFilters", GridFiltersComponent)
  .component("gridFiltersTagAvatar", GridFiltersTagAvatarComponent)
  .component("gridSorting", GridSortingComponent)
  .component("gridColumns", GridColumnsComponent)
  .component("gridSettings", GridSettingsComponent)
  .service("GridFiltersTagFactory", GridFiltersTagFactory)
  .service("GridFiltersArrayQueryService", GridFiltersArrayQueryService)
  .service("GridFiltersDynamicValueFactory", GridFiltersDynamicValueFactory);

export default mod.name;
